"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4942],{

/***/ 4942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5877);
/* harmony import */ var _components_Ads_Google_AdsTypeGeneratorsMemo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9831);
/* harmony import */ var _Widgets_NewsLetter_NewsLetter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7601);




function SideContent(param) {
    var _shouldRenderAds = param.shouldRenderAds, shouldRenderAds = _shouldRenderAds === void 0 ? true : _shouldRenderAds, _placeholderAds = param.placeholderAds, placeholderAds = _placeholderAds === void 0 ? false : _placeholderAds, _enableNewsLetter = param.enableNewsLetter, enableNewsLetter = _enableNewsLetter === void 0 ? false : _enableNewsLetter;
    var ref;
    var transaction = (ref = (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentHub */ .Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getTransaction();
    var sideContentSpan = transaction && transaction.startChild({
        op: "sideContent"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "z-[2] h-full w-full self-start tablet:w-[336px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sticky top-2",
                children: [
                    shouldRenderAds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Ads_Google_AdsTypeGeneratorsMemo__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        isPlaceholder: placeholderAds,
                        type: "halfpage"
                    }),
                    enableNewsLetter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Widgets_NewsLetter_NewsLetter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                ]
            }),
            sideContentSpan && sideContentSpan.finish()
        ]
    });
}


/***/ })

}]);